import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Ingredient, Recipe } from '../../types/types'

export interface RecipesState {
    allIngredients: Ingredient[];
    allRecipes: Recipe[];
    currentIngredient?: Ingredient;
    currentRecipe?: Recipe;
    isLoading: boolean;
}

const initialState: RecipesState = {
    allIngredients: [],
    allRecipes: [],
    currentRecipe: undefined,
    currentIngredient: undefined,
    isLoading: true
}

export const recipeSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        updateIngredient: (state, action : PayloadAction<Ingredient>) => {
            let updatedIngredient = action.payload
            let ingredients = state.allIngredients
            ingredients = ingredients.filter(x=> x.id != updatedIngredient.id)
            ingredients.push(updatedIngredient)
            if (state.currentIngredient?.id === updatedIngredient.id) {
                state.currentIngredient = updatedIngredient
            }
            state.allIngredients = ingredients
            return state;
        },
        selectIngredient: (state, action: PayloadAction<Ingredient>) => {
            state.currentIngredient = action.payload
        },
        selectRecipe: (state, action: PayloadAction<Recipe>) => {
            state.currentRecipe = action.payload
        },
        setKitchen: (state, action: PayloadAction<RecipesState>) => {
            state.allIngredients = action.payload.allIngredients
            state.allRecipes = action.payload.allRecipes
        },
        setIngredients: (state, action: PayloadAction<Ingredient[]>) => {
            state.allIngredients = action.payload
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload
        } 
    },
    extraReducers: (builder) => { }
})

export const {
    selectIngredient,
    selectRecipe,
    setIngredients,
    setKitchen,
    updateIngredient
} = recipeSlice.actions

export default recipeSlice.reducer

